import { render, staticRenderFns } from "./forage.vue?vue&type=template&id=592e69a4&"
import script from "./forage.vue?vue&type=script&lang=js&"
export * from "./forage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports